import FeltoltesAdatlapDto from 'app/admin/feltoltesadatlap/dto/FeltoltesAdatlapDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class FeltoltesAdatlapTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgazoAdatlapUploadTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, FeltoltesAdatlapDto)))
				.catch(reject);
		});
	}
}

export default new FeltoltesAdatlapTableService();
